<wl-how-to-questionnaire-question
  [rendering]="firstQuestion"
  [containerRendering]="rendering"
  [questions]="questions"
  [backToPreviousButtonText]="backToPreviousButtonText"
  [backToBeginningButtonText]="backToBeginningButtonText"
  [step]="1"
  trackImpression="contentblock-impression"
  [trackImpressionInfo]="rendering"
  [trackImpressionContext]="context"
></wl-how-to-questionnaire-question>
